<ng-container *transloco="let tButtons; read: 'buttons'">
    @if (field.operation_code_entity; as oc) {
        <app-modal-layout [containerLayout]="containerLayout" (closeModal)="close()">
            <ng-container title>
                {{ tButtons('options') }}
            </ng-container>
            <app-tb-menu-list [containerLayout]="containerLayout" [insideModalLayout]="true">
                <app-tb-menu-list-item
                    *appOperation="oc; target: 'update'"
                    (click)="editField()"
                    icon="custom_edit"
                >
                    {{ tButtons('edit') }}
                </app-tb-menu-list-item>
                <app-tb-menu-list-item
                    *appOperation="oc; target: 'copy'"
                    (click)="duplicateField()"
                    icon="custom_copy"
                >
                    {{ tButtons('duplicate') }}
                </app-tb-menu-list-item>
                <ng-container *appEnv="'prod'; visible: false">
                    <app-tb-menu-list-item
                        *appOperation="oc; target: 'freeze'; condition: isShareAvailable"
                        icon="custom_share"
                    >
                        {{ tButtons('share') }} (not_implemented)
                    </app-tb-menu-list-item>
                </ng-container>
                <ng-container *appOperation="oc; target: 'delete'">
                    <app-tb-divider></app-tb-divider>
                    <app-tb-menu-list-item (click)="deleteField.emit()">
                        <app-tb-icon color="red-600" icon="custom_trash" item-icon></app-tb-icon>
                        <span class="text-red-600 body-1" item-title>
                            {{ tButtons('delete') }}
                        </span>
                    </app-tb-menu-list-item>
                </ng-container>
            </app-tb-menu-list>
        </app-modal-layout>
    }
</ng-container>
